import { Observable } from "rxjs";
import { Injectable } from "@angular/core";

import * as _ from "lodash";

import { URLSearchParams } from '@angular/http'
import { HttpBackendService } from "app/services/http-backend.service";
import { Asset } from "app/models/asset";
import { PagedResult } from "app/models/PagedResult";
import { ServiceObjectBase } from "app/models/serviceObject";
import { LocationService } from "app/services/location.service";

@Injectable()
export class AssetService {

  constructor(
    private _http: HttpBackendService
  ) { }

public getAssetPath(id: number): Observable<ServiceObjectBase[]> {
  return this._http.get("/api/serviceObject/" + id + "/getserviceobjectpath", null, true)
    .map(resp => {
      let result: ServiceObjectBase[] = [];

      resp.json().forEach(value => {
        var serviceObject = ('Address' in value) ?
        LocationService.convertLocationDTO2Object(value) : AssetService.convertAssetDTO2Object(value);
        result.push(serviceObject);
      });
      return result;
    });
}



  public getAssetDetails(id: number): Observable<Asset> {
    let params = new URLSearchParams;
    params.append('$select', "Id,Name,ServiceObjectType,Status,IsOnService,IsDeleted");
    params.append('$expand', "Children($filter=IsDeleted eq false;$orderby=Name asc)");

    return this._http.get("/api/odata/assets(" + id + ")", params, true)
      .map(resp => {
        return AssetService.convertAssetDTO2Object(resp.json())
      });
  }

  public getAssetsByName(name: string): Observable<Asset[]> {
    let params = new URLSearchParams;
    params.append('$filter', `IsDeleted eq false and (contains(tolower(Name), '${name.toLocaleLowerCase()}') or contains(tolower(Address), '${name.toLocaleLowerCase()}'))`)
    params.append('$select', "Id,Name,ServiceObjectType");

    return this._http.get("/api/odata/assets", params, true)
      .map(resp => {
        let result = _.map(resp.json().value, function (value) {
          return AssetService.convertAssetDTO2Object(value);
        });

        return result;
      });
  }

  public getChildrenForParentId(parentId: number, sortBy: string, isDesc: boolean, count: number, skip: number): Observable<PagedResult<Asset>> {
    let params = new URLSearchParams;

    params.append('$orderby', sortBy + (isDesc ? " desc" : " asc"));
    params.append('$expand', "Parent($select=Id)");
    params.append('$top', count ? count.toString() : null);
    params.append('$skip', skip ? skip.toString() : null);
    params.append('$count', "true");
    params.append('$filter', "IsDeleted eq false and Parent/Id eq " + parentId);


    return this._http.get("/api/odata/serviceObjects", params, true)
      .map(resp => {
        let pagedResult = resp.json();
        let result = new PagedResult<Asset>();

        result.items = _.map(pagedResult.value, function (value) {
          return AssetService.convertAssetDTO2Object(value);
        });

        result.totalCount = pagedResult["@odata.count"];

        return result;
      });
    }
}

export namespace AssetService {
  export function convertAssetDTO2Object(dto: any, asset: Asset = new Asset()): Asset {
    asset.id = dto.Id;
    asset.name = dto.Name;
    asset.type = dto.ServiceObjectType != null ? dto.ServiceObjectType.Name : "-";
    asset.status = this.convertAssetStatusDTO2ObjectStatus(dto.Status);
    asset.isOnService = dto.IsOnService;
    asset.isDeleted = dto.IsDeleted;

    const discriminator = dto['@odata.type'];
    if (discriminator)
      asset.discriminator = discriminator.split('.').pop();

    asset.children = _.map(dto.Children, function (value) {
      return AssetService.convertAssetDTO2Object(value);
    });

    return asset;
  };

  export function convertAssetStatusDTO2ObjectStatus(status: string): Asset.Status {
    switch (status) {
      case 'NotInstalled':
        return Asset.Status.NotInstalled;
      case 'Installed':
        return Asset.Status.Installed;
      default:
        return null;
    }
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/asset.service.ts